
import "./Dice.scss";
import store, { RootState } from "../../store/store";
import { useAppSelector } from "../../hooks/redux";
import PlayerPicture from "../Players/PlayerPicture";
import Dice from "./Dice";
import { GameStatus } from "../../models/GameStatus";

export default function StatusDice() {
  const gameState = store.getState().game;
  const diceState = useAppSelector((state: RootState) => state.dice);

  const dicePlayer = gameState.players.find(it => it.playerId === diceState.playerId) || null;

  if (!diceState.value) {
    return null;
  }

  return (
    <div className="status-dice">
      <div className="status-dice_player">
        {diceState.playerId &&
          <PlayerPicture size={32} player={dicePlayer} hideInitials={true} />
        }
      </div>
      <div className="status-dice_value">
        <Dice
          value={diceState.value}
          isLoading={diceState.isLoading}
          isActive={
            (dicePlayer?.playerId !== gameState.player?.data.playerId || !dicePlayer) &&
            (
              !gameState.settings.customRules ||
              (
                !!gameState.player?.data.isStoryteller &&
                gameState.status === GameStatus.SENTENCE
              )
            )
          }
        />
      </div>
    </div>
  )
}
